<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formQuotationSolution">
        <div class="p-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Importar Despiece'" [severity]="'contrast'" (onClick)="openImportBreakdown()"
                [icon]="'pi pi-file-import'"></app-custom-button>
              <app-custom-modal #importBreakdown [label]="'Seleccionar'" [header]="'Importar Despiece'"
                [children]="componentImportBreakdown" [inputs$]="inputsForImport$" [output$]="outputImport$"
                [width]="'40vw'" [breakpoints]="breakpointsForImport" hidden></app-custom-modal>

              <app-custom-button [title]="'Artículos Compuestos'" [severity]="'contrast'" [icon]="'pi pi-file-plus'"
                (onClick)="openCompositeArticle()"></app-custom-button>
              <app-custom-modal #compositeArticle [label]="'Artículos Compuestos'" [header]="'Artículos Compuestos'"
                [children]="componentCompositeArticle" [width]="'70vw'" hidden
                (selectedItems)="handleImportBreakdown($event)"></app-custom-modal>

              <app-custom-button [title]="'Adjuntar Imágenes'" [severity]="'contrast'" [icon]="'pi pi-paperclip'"
                (onClick)="openAttachImages()"></app-custom-button>
              <app-custom-modal #attachImages [label]="'Adjuntar Imágenes'" [header]="'Adjuntar Imágenes'"
                [children]="componentAttachImages" [inputs$]="inputsForAttachImages$" [output$]="outputAttachImages$"
                [width]="'60vw'" hidden></app-custom-modal>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteSolution()"></app-custom-button>

              <app-custom-button [title]="'Nueva Solución'" [label]="'Nueva Solución'" (onClick)="createNewSolution()"
                [severity]="'success'" [width]="'8.5rem'" [icon]="'pi pi-plus'"
                [variant]="undefined"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <!-- Formulario Captura -->
          <div class="row mt-1 d-flex justify-content-between">
            <div class="col-12 fieldset-quotation">
              <p-fieldset legend="Datos de la cotización">
                <div class="d-flex flex-wrap gap-3 fieldset-content">
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Sucursal:</label>
                    <p class="mb-lg-2 mb-1">{{codeNameBranch}}</p>
                  </div>
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Cotización:</label>
                    <p class="mb-lg-2 mb-1">{{quotationContract.consecutive}}</p>
                  </div>
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Fecha:</label>
                    <p class="mb-lg-2 mb-1">{{quotationContract.dateQuotation | date: 'dd/MM/yyyy'}}</p>
                  </div>
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Cliente:</label>
                    <p class="mb-lg-2 mb-1">{{quotationContract.nameClient}} </p>
                  </div>
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Obra:</label>
                    <p class="mb-lg-2 mb-1">{{quotationContract.nameConstructionSite }}</p>
                  </div>
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Tipo:</label>
                    <p class="mb-lg-2 mb-1">{{quotationTypeName}}</p>
                  </div>
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Versión:</label>
                    <p class="mb-lg-2 mb-1">{{quotationVersionContract.consecutive}}</p>
                  </div>
                  <div class="d-flex me-1">
                    <label class="form-label me-1">Versión Estado:</label>
                    <p class="mb-lg-2 mb-1">{{quotationVersionContract.active ? 'Abierta' : 'Cerrada'}}</p>
                  </div>
                </div>
              </p-fieldset>
              <div class="row gx-5">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div class="row pe-md-3 py-md-2">
                    <!-- Fila 1 (3 campos) -->
                    <div class="col-lg-5 col-md-4 col-sm-6 col-12">
                      <app-custom-autocomplete formControlName="costCenterId" [labelText]="'Centro Costos'"
                        [list]="listCostCenters" (onChangeSelect)="getCostCenter($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                      <app-custom-input-text formControlName="solutionCode" [labelText]="'Solución'" [required]="true">
                      </app-custom-input-text>
                    </div>
                    <div class="col-lg-5 col-md-4 col-sm-6 col-12">
                      <app-custom-input-text formControlName="solutionName" [labelText]="'Nombre Solución'">
                      </app-custom-input-text>
                    </div>

                    <!-- Fila 2 (3 campos) -->
                    <div class="col-lg-2 col-md-4 col-sm-6 col-12 d-flex align-items-center mt-3">
                      <app-custom-checkbox formControlName="swBreakdown" [labelText]="'Despiece'"
                        (onChangeCheckBox)="getSwBreakdown($event)"></app-custom-checkbox>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-select formControlName="baseValue" [labelText]="'Valor Base'" [required]="true"
                        [list]="listBaseValue" (onChangeSelect)="getBaseValue($event)"></app-custom-select>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-select formControlName="unitId" [labelText]="'Unidad'" [required]="true"
                        [list]="listUnits"></app-custom-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div class="row ps-md-3 py-md-2">
                    <!-- Fila 1 -->
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unitario'"
                        [required]="true" [disabled]="true"
                        (onChangeNumber)="getUnitValue($event)"></app-custom-input-decimal>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
                        (onChangeNumber)="getQuantity($event)"></app-custom-input-decimal>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-decimal formControlName="subtotalValue" [labelText]="'Vr.Subtotal'"
                        [required]="true" [disabled]="true"
                        (onChangeNumber)="getSubtotalValue($event)"></app-custom-input-decimal>
                    </div>

                    <!-- Fila 2 -->
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-number formControlName="days" [labelText]="'Días'" [required]="true"
                        (onChangeNumber)="calculateTotalsValue()"></app-custom-input-number>

                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-decimal formControlName="totalValue" [labelText]="'Vr.Total'"
                        [disabled]="true"></app-custom-input-decimal>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-decimal formControlName="ivaRate" [labelText]="'% IVA'" [required]="true"
                        (onChangeNumber)="calculateTotalsValue()"></app-custom-input-decimal>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-decimal formControlName="ivaValue" [labelText]="'Vr.IVA'"
                        [disabled]="true"></app-custom-input-decimal>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <app-custom-input-decimal formControlName="totalWithIva" [labelText]="'Total + IVA'"
                        [disabled]="true"></app-custom-input-decimal>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-2">
                      <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                        [width]="'5rem'" (onClick)="send()"></app-custom-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2">
    <app-breakdown [quotationSolution]="quotationSolutionContract" [quotation]="quotationContract"
      [reloadList]="updateTableBreakdown" (breakdownsInSolution)="breakdownsInSolution = $event"
      [userAuthenticated]="userAuthenticated" (reloadSolution)="getQuotationDetailById()"></app-breakdown>
  </div>
</section>